<script>
    import {onMount} from "svelte";
    import {eventBridge} from "../../stores";
    import {faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";
    import { writable } from "svelte/store";
    import ConfirmModal from "./ConfirmModal.svelte";
    import Fa from "svelte-fa";

    const header = "Verbindungsprobleme";
    const message = "Es treten Probleme mit der Internetverbindung auf. Bitte versuchen Sie es später erneut.";
    const isOpen = writable(false);

    onMount(() => {
        $eventBridge.addEventListener("cs:ErrorConnection", () => {
            $isOpen = true;
        });
    });
</script>

<ConfirmModal
    showConfirm={isOpen}
    on:confirm={() => $isOpen = false}>
    <svelte:fragment slot="header">
        <Fa icon={faTriangleExclamation}/>
        {header}
    </svelte:fragment>

    {message}
</ConfirmModal>